<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>查询条件</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="storeOrderCartInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="storeOrderCartInfo.conditions.orderId" placeholder="订单编号"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="storeOrderCartInfo.conditions.cartType" style="width:100%">
                <el-option label="请选择类型" value=""></el-option>
                <el-option v-for="(item, index) in storeOrderCartInfo.cartTypes" :key="index" :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="storeOrderCartInfo.conditions.state" style="width:100%">
                <el-option label="请选择状态" value=""></el-option>
                <el-option v-for="(item, index) in storeOrderCartInfo.states" :key="index" :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="storeOrderCartInfo.conditions.prodName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="storeOrderCartInfo.conditions.personName" placeholder="用户名称"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="storeOrderCartInfo.conditions.startTime"
              type="datetime"
              placeholder="创建开始时间"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="storeOrderCartInfo.conditions.endTime"
              type="datetime"
              placeholder="创建结束时间"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryOrdersMethod()">
              <i class="el-icon-search"></i> 查询
            </el-button>
            <el-button type="primary" size="small" @click="_resetOrdersMethod()">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>订单信息</div>
        <div class="ibox-tools">
          <el-button type="primary" size="small" @click="_exportOrder()">
            导出
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="storeOrderCartInfo.orders" style="width: 100%" border stripe>
          <el-table-column prop="orderId" label="订单号" align="center"></el-table-column>
          <el-table-column label="商品名称" align="center">
            <template slot-scope="scope">
              <div v-for="(cart, cIndex) in scope.row.storeOrderCartDtos" :key="cIndex">{{ cart.prodName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="购买数量" align="center">
            <template slot-scope="scope">
              <div v-for="(cart, cIndex) in scope.row.storeOrderCartDtos" :key="cIndex">x {{ cart.cartNum }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="appName" label="平台" align="center"></el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.cartType == '3307' ? '服务' : '商品' }}
            </template>
          </el-table-column>
          <el-table-column prop="personName" label="用户名称" align="center"></el-table-column>
          <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
          <el-table-column prop="payWayName" label="支付方式" align="center"></el-table-column>
          <el-table-column label="优惠金额" align="center">
            <template slot-scope="scope">
              {{ formatOrderDiscount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="stateName" label="订单状态" align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button-group>
                <el-button v-if="scope.row.state == '0' && scope.row.cartType == '3306'" size="mini"
                  @click="_openSendOrderCartModel(scope.row)">
                  发货
                </el-button>
                  <el-button v-if="scope.row.state == '2'" size="mini" @click="_confirmOrderCart(scope.row)">
                      确认收货
                  </el-button>
                <el-button v-if="scope.row.state == '00' && scope.row.cartType == '3306'" size="mini"
                  @click="_toStockUpOrder(scope.row)">
                  备货完成
                </el-button>
                <el-button v-if="scope.row.state != '1001'" size="mini" @click="_openOrderPrint(scope.row)">
                  补打小票
                </el-button>
                <el-button size="mini" @click="_openOrderDetailModel(scope.row)">
                  订单详情
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="storeOrderCartInfo.conditions.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="storeOrderCartInfo.conditions.row"
          layout="total, sizes, prev, pager, next, jumper"
          :total="storeOrderCartInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>

    <send-store-order-cart ref="sendStoreOrderCart"></send-store-order-cart>
  </div>
</template>

<script>
import { queryStoreOrder, exportData, orderPrinter, confirmStoreOrderCart } from '@/api/order/storeOrderCartApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import SendStoreOrderCart from '@/components/order/sendStoreOrderCart/sendStoreOrderCart'

export default {
  name: 'StoreOrderCart',
  components: {
    SendStoreOrderCart
  },
  data() {
    return {
      storeOrderCartInfo: {
        orders: [],
        total: 0,
        records: 1,
        orderDetail: false,
        moreCondition: false,
        states: [],
        cartTypes: [],
        conditions: {
          cartId: '',
          orderId: '',
          state: '',
          personName: '',
          cartType: '',
          prodName: '',
          startTime: '',
          endTime: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    formatOrderDiscount(row) {
      const deduction = parseFloat(row.deduction || 0)
      const couponDiscount = parseFloat(row.couponDiscount || 0)
      return (deduction + couponDiscount).toFixed(2)
    },
    _initMethod() {
      this._listOrders(this.storeOrderCartInfo.conditions.page, this.storeOrderCartInfo.conditions.row)
      this._getDictData()
    },
    async _getDictData() {
      try {
        const { data: stateData } = await getDict('store_order', 'state')
        const { data: cartTypeData } = await getDict('store_order_cart', 'cart_type')
        this.storeOrderCartInfo.states = stateData
        this.storeOrderCartInfo.cartTypes = cartTypeData
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    _normalizeTimeConditions() {
      const conditions = this.storeOrderCartInfo.conditions
      if (!conditions.startTime) {
        conditions.startTime = ''
      }
      if (!conditions.endTime) {
        conditions.endTime = ''
      }
    },
    _validateTimeRange() {
      this._normalizeTimeConditions()
      const { startTime, endTime } = this.storeOrderCartInfo.conditions
      if (startTime && endTime && startTime > endTime) {
        this.$message.warning('创建开始时间不能大于结束时间')
        return false
      }
      return true
    },
    async _listOrders(page, rows) {
      if (!this._validateTimeRange()) {
        return
      }
      this.storeOrderCartInfo.conditions.page = page
      this.storeOrderCartInfo.conditions.row = rows
      let shopId = getShopId()
      this.storeOrderCartInfo.conditions.shopId = shopId

      try {
        const res = await queryStoreOrder(this.storeOrderCartInfo.conditions)
        this.storeOrderCartInfo.total = res.total
        this.storeOrderCartInfo.records = res.records
        this.storeOrderCartInfo.orders = res.data

        this.storeOrderCartInfo.orders.forEach(item => {
          if (Object.prototype.hasOwnProperty.call(item, 'productSpecDetails')) {
            let _specValue = ''
            item.productSpecDetails.forEach(detail => {
              _specValue += (detail.detailValue + "/")
            })
            item.specValue = _specValue
          }
        })
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    handleSizeChange(val) {
      this.storeOrderCartInfo.conditions.row = val
      this._listOrders(this.storeOrderCartInfo.conditions.page, val)
    },
    handleCurrentChange(val) {
      this._listOrders(val, this.storeOrderCartInfo.conditions.row)
    },
    _queryOrdersMethod() {
      this._listOrders(1, this.storeOrderCartInfo.conditions.row)
    },
    _resetOrdersMethod() {
      const row = this.storeOrderCartInfo.conditions.row
      this.storeOrderCartInfo.conditions = {
        cartId: '',
        orderId: '',
        state: '',
        personName: '',
        cartType: '',
        prodName: '',
        startTime: '',
        endTime: '',
        shopId: '',
        page: 1,
        row
      }
      this._listOrders(1, row)
    },
    _openOrderDetailModel(order) {
      this.$router.push(`/pages/goods/storeOrderCartDetail?orderId=${order.orderId}`)
    },
    _openSendOrderCartModel(order) {
      this.$refs.sendStoreOrderCart.open(order)
    },
    _toStockUpOrder(order) {
      this.$router.push(`/pages/order/stockUpStoreOrder?orderId=${order.orderId}`)
    },
    async _openOrderPrint(order) {
      let shopId = await getShopId()
      const param = {
        shopId: shopId,
        orderId: order.orderId
      }
      try {
        const res = await orderPrinter(param)
        this.$message.success(res.msg)
      } catch (error) {
        this.$message.error(error)
      }
    },
    async _exportOrder() {
      if (!this._validateTimeRange()) {
        return
      }
      try {
        this.storeOrderCartInfo.conditions.shopId = getShopId()
        this.storeOrderCartInfo.conditions.pagePath = 'storeOrderCart'
        const res = await exportData(this.storeOrderCartInfo.conditions)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心&fileType=storeOrderCart')
        }
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
      async _confirmOrderCart(order) {//确认收货
        let flag = true
          try {
              for (const orderCart of order.storeOrderCartDtos) {
                  const res = await confirmStoreOrderCart({
                      orderId: orderCart.orderId,
                      cartId: orderCart.cartId,
                      shopId: orderCart.shopId
                  })
                  if (res.code === 0) {
                      if (flag) {
                          this.$message.success('确认发货成功')
                      }
                      flag = false
                  } else {
                      this.$message.error(res.msg)
                  }
              }
          } catch (error) {
              console.error('请求失败处理', error)
          } finally {
              this._initMethod()
          }
      }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #edf1f2;
  border-image: none;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>
